import React, { createContext, useState, ReactNode } from "react";
import { setAdminToken, clearAdminToken } from "../apiAdmin";

export interface AdminUser {
  _id: string;
  name: string;
  email: string;
  role: string;
}

interface AdminAuth {
  admin: AdminUser | null;
  loading: boolean;
  login: (user: AdminUser, token: string) => void;
  logout: () => void;
}

export const AdminAuthContext = createContext<AdminAuth>({} as AdminAuth);

export const AdminAuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [admin, setAdmin] = useState<AdminUser | null>(() => {
    try {
      const userStr = typeof window !== "undefined" ? localStorage.getItem("admin-user") : null;
      if (userStr) {
        const parsed = JSON.parse(userStr);
        return parsed && parsed._id ? parsed : null;
      }
    } catch {}
    return null;
  });

  const [loading] = useState<boolean>(false);

  const login = (user: AdminUser, token: string) => {
    setAdmin(user);
    setAdminToken(token);
    try {
      localStorage.setItem("admin-token", token);
      localStorage.setItem("admin-user", JSON.stringify(user));
    } catch {}
  };

  const logout = () => {
    setAdmin(null);
    clearAdminToken();
    try {
      localStorage.removeItem("admin-token");
      localStorage.removeItem("admin-user");
    } catch {}
  };

  return (
    <AdminAuthContext.Provider value={{ admin, login, logout, loading }}>
      {children}
    </AdminAuthContext.Provider>
  );
};
